import React, { useState, useEffect } from 'react';

const BLUE = '#5352ed';
const NAVY = '#0C2D48';

export default function FeatureGuide({ steps = [], open, onClose, onComplete }) {
  const [step, setStep] = useState(0);

  useEffect(() => {
    if (open) setStep(0);
  }, [open]);

  if (!open || steps.length === 0) return null;

  const current = steps[step];
  const isFirst = step === 0;
  const isLast = step === steps.length - 1;

  return (
    <>
      {/* Backdrop */}
      <div
        onClick={onClose}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.42)', zIndex: 4000 }}
      />

      {/* Guide card */}
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Feature guide"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 'calc(100vw - 2rem)',
          maxWidth: 480,
          maxHeight: '85dvh',
          overflowY: 'auto',
          background: '#fff',
          borderRadius: 14,
          boxShadow: '0 8px 40px rgba(0,0,0,0.22)',
          zIndex: 4001,
          boxSizing: 'border-box',
          fontFamily: "'Raleway', sans-serif",
        }}
      >
        {/* Header */}
        <div style={{ display: 'flex', alignItems: 'center', padding: '1rem 1.25rem 0.7rem', borderBottom: '1px solid #f0f0f0', flexShrink: 0 }}>
          <span style={{ fontSize: '0.72rem', fontWeight: 700, color: BLUE, textTransform: 'uppercase', letterSpacing: '0.07em' }}>
            Step {step + 1} of {steps.length}
          </span>
          <button
            onClick={onClose}
            aria-label="Close guide"
            style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.25rem', color: '#aaa', lineHeight: 1, padding: '0.15rem 0.3rem', fontFamily: 'inherit' }}
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div style={{ padding: '1rem 1.25rem 0.25rem' }}>
          <h3 style={{ margin: '0 0 0.55rem', fontSize: '1.05rem', fontWeight: 800, color: NAVY, fontFamily: "'Poppins', sans-serif", lineHeight: 1.3 }}>
            {current.title}
          </h3>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#444', lineHeight: 1.65 }}>
            {current.body}
          </p>
        </div>

        {/* Step dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, padding: '0.85rem 1.25rem 0' }}>
          {steps.map((_, i) => (
            <div
              key={i}
              style={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                background: i === step ? BLUE : '#e0e0e0',
                transition: 'background 0.15s',
                flexShrink: 0,
              }}
            />
          ))}
        </div>

        {/* Buttons */}
        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', padding: '0.8rem 1.25rem 1.1rem', flexWrap: 'wrap' }}>
          {!isFirst && (
            <button
              onClick={() => setStep(s => s - 1)}
              style={{ padding: '0.5rem 1.1rem', border: '1.5px solid #ddd', borderRadius: 7, background: '#fff', color: '#444', fontWeight: 600, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Back
            </button>
          )}
          {!isLast ? (
            <button
              onClick={() => setStep(s => s + 1)}
              style={{ padding: '0.5rem 1.4rem', border: 'none', borderRadius: 7, background: BLUE, color: '#fff', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Next
            </button>
          ) : (
            <button
              onClick={onComplete}
              style={{ padding: '0.5rem 1.4rem', border: 'none', borderRadius: 7, background: BLUE, color: '#fff', fontWeight: 700, fontSize: '0.85rem', cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Got it
            </button>
          )}
        </div>
      </div>
    </>
  );
}
